import styled from '@emotion/styled'

export const TutorialTipsContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  padding: 12px 24px 38px 24px;

  display: grid;
  align-items: center;
  justify-items: center;
`
